import type { NavItem } from "../../types";
import { site } from "../../data";
import { Container } from "../ui/Container";
import { MainNav } from "./MainNav";
import "./Header.css";
import { assetUrl, cartUrl, siteUrl } from "../../wordpress";

type HeaderProps = {
	nav: NavItem[];
	cartCount: number;
	menuOpen: boolean;
	onToggleMenu: () => void;
	firstVisit: boolean;
};

/**
 * Barra única e fixa: marca à esquerda, navegação e ações à direita. Abaixo de
 * 992px a navegação recolhe para o menu lateral e sobra o hambúrguer.
 */
export function Header({
	nav,
	cartCount,
	menuOpen,
	onToggleMenu,
	firstVisit,
}: HeaderProps) {
	return (
		<header className="header" id="header">
			<Container className="header__inner">
				<button
					type="button"
					className="header__burger"
					onClick={onToggleMenu}
					aria-expanded={menuOpen}
					aria-controls="side-menu"
				>
					<span />
					<span className="visually-hidden">menú</span>
				</button>

				<a
					className={firstVisit ? "brand brand--intro" : "brand"}
					href={siteUrl("/")}
					data-wordmark={site.name}
				>
					<img src={assetUrl(site.logo)} alt={site.legalName} />
				</a>

				<MainNav items={nav} />

				<div className="header__actions">
					<a className="header__icon" href={cartUrl()}>
						<CartIcon />
						<span className="header__cart-count">{cartCount}</span>
						<span className="visually-hidden">cistella</span>
					</a>
				</div>
			</Container>
		</header>
	);
}

const iconProps = {
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.6,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	"aria-hidden": true,
	focusable: false,
} as const;

function CartIcon() {
	return (
		<svg {...iconProps}>
			<path d="M2.5 3h2.2l2.3 11.2a1.6 1.6 0 0 0 1.6 1.3h8.6a1.6 1.6 0 0 0 1.6-1.2l1.6-6.4H6.1" />
			<circle cx="9.3" cy="19.5" r="1.5" />
			<circle cx="17.2" cy="19.5" r="1.5" />
		</svg>
	);
}
